import React from "react";
import { Helmet } from "react-helmet";

import {
  About,
  Education,
  Experience,
  Footer,
  Landing,
  Navbar,
  Services,
  Skills,
} from "../../components";
import { headerData } from "../../data/headerData";

function Main() {
  return (
    <div>
      <Helmet>
        <title>{headerData.name} - Porfolio</title>
      </Helmet>

      <Navbar />
      <Landing />
      <About />
      <Education />
      <Skills />
      <Experience />
      {/* <Projects /> */}
      <Services />
      <Footer />
    </div>
  );
}

export default Main;
